export const isPrimaryInputHandle = (handle) => {
  const normalized = String(handle ?? 'input_0').replace('input_', '');
  return normalized === '' || normalized === '0';
};

const edgeRank = (edge) => {
  const primaryHandleRank = isPrimaryInputHandle(edge.targetHandle) ? 0 : 1;
  const normalizedTargetHandle = String(edge.targetHandle ?? 'input_0').replace('input_', '');
  return [
    primaryHandleRank,
    normalizedTargetHandle,
    String(edge.source || ''),
    String(edge.sourceHandle || '')
  ];
};

const isBetterEdge = (candidate, current) => {
  const a = edgeRank(candidate);
  const b = edgeRank(current);
  for (let i = 0; i < a.length; i += 1) {
    if (a[i] < b[i]) return true;
    if (a[i] > b[i]) return false;
  }
  return false;
};

export const sanitizeIncomingEdgesForIndicatorNodes = (edgeList = [], nodeList = []) => {
  const indicatorIds = new Set(
    (nodeList || [])
      .filter((node) => node?.type === 'indicator')
      .map((node) => node.id)
  );

  const nonIndicatorEdges = [];
  const selectedIndicatorInputEdge = new Map();

  (edgeList || []).forEach((edge) => {
    if (!edge?.source || !edge?.target) return;

    if (indicatorIds.has(edge.target)) {
      const current = selectedIndicatorInputEdge.get(edge.target);
      if (!current || isBetterEdge(edge, current)) {
        selectedIndicatorInputEdge.set(edge.target, edge);
      }
      return;
    }

    nonIndicatorEdges.push(edge);
  });

  return [...nonIndicatorEdges, ...Array.from(selectedIndicatorInputEdge.values())];
};
